import React, { Component } from 'react';
import { Row, Col, Navbar, Nav, Button, Form, Modal } from 'react-bootstrap';
import moment from 'moment';

import Auth from '../../Auth/Auth';

const auth = new Auth();

function parseJwt (token) {  
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

function convertToLocal(date){
    var stillUtc = moment.utc(date).toDate();
    var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    return local;
}

function statusColor(item){
    let timecheck = 0;
    const containsFailed = item.data.map(el =>  el.toUpperCase().indexOf("FAILED") > -1).includes(true);
    const containsSQLError = item.data.map(el => el.toUpperCase().indexOf("SQL ERROR") > -1).includes(true);

    switch(item.log){
        case "Confluence" : timecheck = 125;
        break;

        default : timecheck = 125;
        break;
    }

    if(item.data.length > 0){
        if(moment(item.lastModified) > moment().subtract(timecheck, 'minutes') ){   
            if(containsSQLError){
                return {backgroundColor : "#000000"};
            } 
            if(containsFailed){
                return {backgroundColor : "#ffa500"};
            }             
            return {backgroundColor : "#469a46"};
        } else {
            return {backgroundColor : "#ff1515"};
        }
    } else {
        return {backgroundColor : "#ff1515"};
    }
}

export default class ProcessLogging extends Component {
    constructor(props){
        super(props);

        this.state = {
            Health : [],
            getTheseLogs: ["SF","Jira","Communities","CeridianHelpHub"],
            Logs : [],
            selectedLogData: [],
            Announcements: []
        };
    }

    async componentDidMount(){
        let self = this;
        let accessToken = await auth.getToken();
        let jwt = parseJwt(localStorage.getItem("msal.idtoken"));

        fetch(`/files/ErrorLogs`,{
            method : "GET",
            headers : {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                errorsLogsRequested: JSON.stringify(this.state.getTheseLogs)
            }
        }).then(success => success.json())
        .then(data => { 
          this.setState({
            Logs : data.sort(function(a, b){ 
                return a.logId - b.logId;
            })
          });
        });
        
        fetch('/api/Announcements', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        })
        .then(data => {           
            if(data[0] && data[0].length > 0){
                let ErrorArr = [];
                let ErrSet = new Set();
                ErrorArr = data[0].filter(el => el.isActive === true && el.Title.indexOf("Issues") > -1);
                for(var i = 0; i < ErrorArr.length; i++){
                    ErrSet.add(ErrorArr[i].Title.replaceAll("Fetch","").replaceAll("Issues","").trim());
                }
                this.setState({
                    Announcements : Array.from(ErrSet)
                });
            }
        }).catch((error) => {
            window.apiError(error);
        }); 
        

        fetch(`${process.env.PUBLIC_URL}/config.json`)
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            let config = data.config;
            if(config.ErrorNotification.includes(jwt.oid)){
                this.setState({
                    AdminTab : true
                });
            }
        }).catch((error) => {
            window.apiError(error);
        });
    }

    async getError(){
        let accessToken = await auth.getToken();
        fetch(`/files/ErrorLogs`,{
            method : "GET",
            headers : {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                errorsLogsRequested: JSON.stringify(this.state.getTheseLogs)
            }
        }).then(success => success.json())
        .then(data => { 
          this.setState({
            Logs : data.sort(function(a, b){ 
                return a.logId - b.logId;
            })
          });
        });
    }

    showLogInfo(item){
        this.setState({ 
            showLogDataModal : true, 
            selectedLogData : item.data, 
            selectedLog : item.log 
        });   
    }

    async AddErrorAnnouncement(e, selectedLog){
        let accessToken = await auth.getToken();
        let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
        fetch('/api/ErrorAnnouncements', {
            method : "POST",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                details: selectedLog
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        })
        .then(success => {
            this.setState({
                Announcements : [...this.state.Announcements, selectedLog]
            });
        }).catch((error) => {
            window.apiError(error);
        });
    }

    async RemoveErrorAnnouncement(e, selectedLog){
        let accessToken = await auth.getToken();
        let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
        fetch('/api/RemoveErrorAnnouncements', {
            method : "POST",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                details: selectedLog
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        })
        .then(success => {
            let AnnouncementArr = this.state.Announcements.filter(el => el.Title !== selectedLog);
            this.setState({
                Announcements : [AnnouncementArr]
            });
        }).catch((error) => {
            console.error('Error:', error);
        });
    }    

    render () {     
        return (
            <div>
                <Row>
                    <Col lg={{span : 12}} className="mt-3">
                    <span>Logs</span>
                    <div className="legend">
                        <span><div className="color-box" style={{backgroundColor: "rgb(70, 154, 70)"}}></div> Running  <div className="color-box" style={{backgroundColor: "rgb(255, 165, 0)"}} ></div>  Running but with failed <div className="color-box" style={{backgroundColor: "#000000"}} ></div>  Running but has SQL errors  <div className="color-box" style={{backgroundColor: "rgb(255, 21, 21)"}}></div>  Has stopped or critical error</span>
                    </div>
                    </Col>
                    
                    {this.state.Logs.map((items,index) =>
                    <Col lg={{span : 3}} key={index}>
                        <div className="kpi-box log-box pt-3 mb-3" style={statusColor(items)} onClick={() => this.showLogInfo(items)}>
                            <h4 style={{color : "white"}}>{items.log}</h4>
                            <span style={{color : "white"}}>{convertToLocal(items.lastModified)}</span>
                        </div>
                    </Col>
                    )}
                </Row>

                <Modal show={this.state.showLogDataModal} onHide={() => this.setState({ showLogDataModal : false, selectedLogData: [] })} dialogClassName=" log-details-modal active" animation={false}>
                   {this.state.AdminTab && (
                    <span style={{fontSize: "22px", color : "grey"}}>Log for {this.state.selectedLog} 
                    {(this.state.Announcements.includes(this.state.selectedLog)) === true ?
                        <Button variant="link" className="float-right" onClick={(e) => this.RemoveErrorAnnouncement(e,this.state.selectedLog)}>Remove Error Announcement</Button>
                    :
                        <Button variant="link" className="float-right" onClick={(e) => this.AddErrorAnnouncement(e,this.state.selectedLog)}>Put up Error Announcement</Button>
                    }                   
                    </span>
                   )}

                    {/* Latest activity on Log */}
                   <div style={{border : "solid 2px green", padding: "10px"}}>
                    <small><strong>Latest activity on this log</strong></small>
                   {this.state.selectedLogData.map((items,index) => 
                    index > (this.state.selectedLogData.length - 10) &&  (      
                        <small key={index} className={items.indexOf("Service Started") > -1 ? "mt-3 font-weight-bold" : ""} style={items.indexOf("Failed") > -1 ? {color : "red"} : items.indexOf("SQL ERROR") > -1 ? {color : "red"} : {}}>
                            {items}                        
                        </small>
                        )
                    )}
                   </div>
                    

                   {this.state.selectedLogData.map((items,index) =>                   
                    <small key={index} className={items.indexOf("Service Started") > -1 ? "mt-3 font-weight-bold" : ""} style={items.indexOf("Failed") > -1 ? {color : "red"} : items.indexOf("SQL ERROR") > -1 ? {color : "red"} : {}}>
                        {items}                        
                    </small>
                   )}
                </Modal>
            </div>
        );
    }
}